<template>
  <smd-one-col-layout>
    <div class="smd-form__row">
      <text-string label-id="txt127"/>
    </div>
    <div class="smd-form__row">
      <text-string label-id="txt128"/>
    </div>
    <div class="smd-form__row flex-row-center-xy-spaced">
      <smd-btn section="4"
               variant="unselected"
               @click="exitFn">
        <text-string label-id="txt129"/>
      </smd-btn>
      <smd-btn section="4"
               variant="blue-enabled"
               @click="continueFn">
        <text-string label-id="txt130"/>
      </smd-btn>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import CloseModalMixin from '@/mixins/close-modal-mixin';

  export default {
    name: "modal-confirm-exit",
    mixins: [CloseModalMixin],
    methods: {
      exitFn() {
        this.closeModal({success: true});
      },
      continueFn() {
        this.closeModal({success: false});
      }
    }
  }
</script>

<style scoped>

</style>